import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./timezone.js";
//#region src/timezone_helper.ts
var timezone_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(timezone) {
	switch (timezone) {
		case "America/Chicago":
		case "America/Winnipeg": return "CT";
		case "America/Denver":
		case "America/Edmonton": return "MT";
		case "America/Los_Angeles": return "PT";
		case "America/New_York":
		case "America/Toronto": return "ET";
		case "America/Phoenix": return "Arizona";
		case "America/Puerto_Rico": return "Puerto Rico";
		case "Pacific/Honolulu": return "Hawaii";
		default: return timezone;
	}
}
//#endregion
export { name, timezone_helper_exports };

//# sourceMappingURL=timezone_helper.js.map